import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-grid-banner',
  templateUrl: './grid-banner.component.html',
  styleUrls: ['./grid-banner.component.css']
})
export class GridBannerComponent implements OnInit {

  @Input() currentPage: string;
  
  constructor() { }

  ngOnInit() {
  }

}
